// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__vsb6F","employee-header-item":"Header_employee-header-item__ROAuB"};